import { mutations } from "./mutations";
import Events from "./events";
export const initialState = () => {
    return {
        allJobs: [],
        visibleJobs: [],
        selectedJobs: [],
        allGeometries: [],
        selectedGeometries: [],
        jobLocations: [],
        jobLocationsAll: [],
        selectedLocation: [],
    };
};
export class Store {
    constructor(mutations, state) {
        this.events = new Events();
        this.mutations = mutations;
        this.state = new Proxy(state || initialState(), {
            set: (state, key, value) => {
                state[key] = value;
                this.events.publish("STATE_CHANGE", state);
                this.events.publish("STATE_CHANGE_" + key.toUpperCase(), state);
                return true;
            },
        });
    }
    getState() {
        return this.state;
    }
    dispatch(mutationName, payload) {
        if (typeof this.mutations[mutationName] !== "function") {
            console.error(`Mutation "${mutationName}" doesn't exist`);
            return false;
        }
        return this.mutations[mutationName](this.state, payload);
    }
}
export function newDefaultStore() {
    return new Store(mutations, initialState());
}
export const globalStore = newDefaultStore();
